(() => {
if (customElements.get('cabane-category-navigation')) return;
class CategoryNavigation extends HTMLElement {
connectedCallback() {
const data=window.CabaneCategoryNavigation;if(!data)return;
const params=new URL(location.href).searchParams;
const handle=location.pathname.split('/collections/')[1]?.split('/')[0];
let key=data.mapping[handle]||this.dataset.default;
const override=params.get(this.dataset.hub==='true'?'rubrique':'navigation');
if(override&&data.groups[override])key=override;
if(this.dataset.pageType==='search'&&!data.groups[override]){
  const words=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().match(/[a-z0-9]+/g)?.map(word=>word.length>3?word.replace(/s$/,''):word)||[];
  const terms=new Set(words(params.get('q')));
  const matches=[];
  for(const [groupKey,group] of Object.entries(data.groups)){
    for(const item of group.items){
      const label=words(item.label);
      if(!item.available||!label.length||!label.every(word=>terms.has(word)))continue;
      const candidate=item.group||data.mapping[item.handle]||groupKey;
      if(data.groups[candidate])matches.push({key:candidate,score:label.length});
    }
  }
  const score=Math.max(0,...matches.map(match=>match.score));
  const candidates=[...new Set(matches.filter(match=>match.score===score).map(match=>match.key))];
  key=candidates.length===1?candidates[0]:'catalogue';
}
if(!data.groups[key])return;
this.hidden=false;this.dataset.category=key;
const group=data.groups[key],grid=this.querySelector('[data-ccn-grid]');
if(this.dataset.hub==='true'&&group.productUrl){
  const destination=new URL((this.dataset.root||'/').replace(/\/$/,'')+group.productUrl,location.origin);
  for(const name of ['univers','preview_theme_id'])if(params.has(name))destination.searchParams.set(name,params.get(name));
  location.replace(destination.href);return;
}
if(this.dataset.pageType==='search'){
  const currentQuery=params.get('q')||'';
  const legacyQuery=(group.legacyProductQueries||[]).find(query=>currentQuery===query||currentQuery.startsWith('('+query+') AND '));
  if(legacyQuery){const target=new URL(location.href);target.searchParams.set('q',currentQuery===legacyQuery?group.productQuery:'('+group.productQuery+')'+currentQuery.slice(legacyQuery.length+2));target.searchParams.delete('page');location.replace(target.href);return;}

  const legacy=group.items.find(item=>item.legacyQuery===params.get('q'));
  if(legacy){const target=new URL(location.href);target.searchParams.set('q',new URL(legacy.url,location.origin).searchParams.get('q'));target.searchParams.delete('page');location.replace(target.href);return;}
  const preserveContext=()=>{
    const current=new URL(location.href).searchParams;
    const context={navigation:current.get('navigation')||key,univers:current.get('univers'),category_search:current.get('category_search'),type:'product'};
    document.querySelectorAll('facet-filters-form form').forEach(form=>{
      for(const [name,value] of Object.entries(context)){
        if(!value)continue;
        let input=form.querySelector('input[name="'+name+'"]');
        if(!input){input=document.createElement('input');input.type='hidden';input.name=name;form.append(input);}
        input.value=value;
      }
    });
    document.querySelectorAll('#MainContent .pagination a[href], #MainContent .js-facet-remove[href]').forEach(link=>{
      const target=new URL(link.href,location.origin);
      if(target.origin!==location.origin||!target.pathname.endsWith('/search'))return;
      for(const [name,value] of Object.entries(context))if(value)target.searchParams.set(name,value);
      link.href=target.pathname+target.search+target.hash;
    });
  };
  preserveContext();
  this.contextObserver?.disconnect();
  const results=document.querySelector('#ProductGridContainer');
  if(results){this.contextObserver=new MutationObserver(preserveContext);this.contextObserver.observe(results,{childList:true,subtree:true});}
}
const root=(this.dataset.root||'/').replace(/\/$/,'');
const local=url=>{if(url.startsWith('/pages/catalogue')&&this.dataset.catalogueUrl){const target=new URL(this.dataset.catalogueUrl,location.origin),source=new URL(url,location.origin);source.searchParams.forEach((value,key)=>target.searchParams.set(key,value));target.hash=source.hash;return target.pathname+target.search+target.hash;}if(url==='/pages/trottinettes'&&this.dataset.catalogueUrl){const target=new URL(this.dataset.catalogueUrl,location.origin);target.searchParams.set('rubrique','scooter');return target.pathname+target.search;}return root+url;};
const rootKeys=data.groups.catalogue.items.map(i=>i.group);
let origin=params.get('univers');
if(!rootKeys.includes(origin))origin=null;
let nativeRoot=key;while(data.groups[nativeRoot].parent&&data.groups[nativeRoot].parent!=='catalogue')nativeRoot=data.groups[nativeRoot].parent;
origin=origin||nativeRoot;
const contextual=url=>{const u=new URL(local(url),location.origin);if(key!=='catalogue'&&rootKeys.includes(origin))u.searchParams.set('univers',origin);return u.pathname+u.search+u.hash;};
const back=document.querySelector('[data-category-back]');
if(back){const parent=data.groups[group.parent];back.href=contextual(parent?.productUrl||parent?.url||'/collections/all');}
if(this.dataset.pageType==='search'&&group.productQuery&&(params.get('q')===group.productQuery||(params.get('q')||'').startsWith('('+group.productQuery+') AND '))){
  const heading=document.querySelector('.collection-hero__title');if(heading){const title=heading.querySelector('.cabane-category-title-main');if(title){const dot=title.querySelector('.cabane-category-title-dot');title.textContent=group.label;if(dot)title.append(dot);}else heading.textContent=group.label;}
  document.title=group.label+' — La Cabane de la Glisse';
}
const pathname=location.pathname.replace(root,'');
const fragment=document.createDocumentFragment();
const visibleItems=group.items.filter(item=>item.available);
for(const item of visibleItems){
const card=document.createElement('a');card.className='ccn__item';
card.href=contextual(item.url);
const itemUrl=new URL(card.href,location.origin);
const isCurrentCollection=item.handle&&pathname==='/collections/'+item.handle;
const isCurrentSearch=this.dataset.pageType==='search'&&itemUrl.pathname.endsWith('/search')&&(itemUrl.searchParams.get('q')===params.get('q')||(params.get('q')||'').startsWith('('+itemUrl.searchParams.get('q')+') AND '));
if(isCurrentCollection||isCurrentSearch)card.setAttribute('aria-current','page');
const photo=document.createElement('span');photo.className='ccn__photo';
if(item.image){const img=document.createElement('img');img.src=item.image.startsWith('asset:')?new URL(item.image.slice(6),document.querySelector('script[src*="/cabane-category-navigation-data.js"]').src).href:item.image;img.alt='';img.width=44;img.height=44;img.loading='lazy';photo.append(img);}
else photo.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14v13H5zM8 7V4h8v3M9 12h6"/></svg>';
const label=document.createElement('span');label.className='ccn__label';label.textContent=item.label;
card.append(photo,label);fragment.append(card);
}
grid.replaceChildren(fragment);grid.dataset.count=visibleItems.length;
if(this.dataset.hub==='true'){
this.querySelector('[data-ccn-title]').textContent=key==='catalogue'?'Choisis ton univers':group.label;
this.querySelector('[data-ccn-intro]').textContent=key==='catalogue'?'Trouve ton équipement, une catégorie à la fois.':'Choisis une rubrique pour découvrir les produits du shop.';
document.title=group.label+' — La Cabane de la Glisse';
}
}
}
customElements.define('cabane-category-navigation',CategoryNavigation);
})();
